import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services';
import { checkTranslation, imageAddress, translate } from '../../utils/useful';
import { Loader } from 'react-loader-spinner';
import Collapsible from 'react-collapsible';
import FramesPlusBut from '../../components/header/FramesPlusBut';

export default class DeskSelectApplet extends Component {

    state = {
        list: [],
        currentApplet: '',
        currentAppletName: '',
        template: [
            // { image: '/assets/icons/applets/drive/drive-folder.svg', title: '{{lang}}New Folder', des: '' },
            // { image: '/assets/icons/note/addnoteimg.svg', title: '{{lang}}New Upload', des: '' },
            // { image: '/assets/icons/note/addnoteimg.svg', title: '{{lang}}New Note', des: '' },
            { image: '/assets/icons/note/n1.png', title: '{{lang}}Resume', des: '{{lang}}Coral' },
            { image: '/assets/icons/note/n2.png', title: '{{lang}}Resume', des: '{{lang}}Serif' },
            { image: '/assets/icons/note/n3.png', title: '{{lang}}Letter', des: '{{lang}}Spearmint' },
            { image: '/assets/icons/note/n4.png', title: '{{lang}}Project proposal', des: '{{lang}}Tropic' },
            { image: '/assets/icons/note/n5.png', title: '{{lang}}Brochure', des: '{{lang}}Geometric' },
            { image: '/assets/icons/note/n6.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n1.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n2.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n3.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n4.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n5.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
            { image: '/assets/icons/note/n6.png', title: '{{lang}}Report', des: '{{lang}}Luxe' },
        ],
        isLoadingList: false,
        collapses: {},
        collapses2: {},
    }

    componentDidMount() {
        console.log('fffffffffffffffffffas', this.props)
        this.fetchList()
    }

    fetchList = () => {
        let data = {}
        data.features = this.props.type
        // this.setState({ isLoadingList: true })
        let list = this.state.list
        HttpServices.request('getMyFramesByType', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            fetchResult.info.map((element, index) => {
                if (element.applet.default) {
                    element.applet.name = element.appletHub.fullname
                }
            })
            list = fetchResult.info
            this.setState({ list, }, () => {
                this.setState({ isLoadingList: false })
            })
        })
    }

    changeApplet = (prop) => {
        let currentApplet = this.state.currentApplet
        let currentAppletName = this.state.currentAppletName
        if (!prop?.applet) {
            currentApplet = ''
            currentAppletName = prop.name
        }
        else {
            currentApplet = prop.applet._id
            currentAppletName = prop.applet.name
        }
        this.setState({ currentApplet, currentAppletName }, () => {
            this.props.setCurrentApplet('currentApplet', currentApplet)
            this.props.setCurrentApplet('currentAppletName', currentAppletName)
            // this.props.changeBaseUrl(currentApplet)
            this.props.changePage('directoryViewer')
            this.props.setCurrentApplet('showDirectory', true)
            return currentApplet
        })
    }

    openSelectAppletModal = (data, func) => {
        if (this.props.currentApplet == '') {
            if (this.props.openSelectAppletModal) {
                this.props.openSelectAppletModal()
            }
            this.props.setData(data, true, 'FileManager')
        }
        else {
            this.props.functionsHandler(null, func)
        }
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? false : !this.state.collapses[key]
        this.setState({ collapses })
    }

    changeCollapse2 = (key) => {
        let collapses2 = this.state.collapses2
        collapses2[key] = this.state.collapses2[key] == null ? false : !this.state.collapses2[key]
        this.setState({ collapses2 })
    }

    showChildren = (parent, data, level) => {
        return (
            <div className={''}>
                {data?.map((item, index) => {
                    if (item.parents && item.parents[item.parents.length - 1] == parent && !item.hideInDashboard)
                        return (
                            <div className={'w-100 ' + (level > 0 ? ' pld-2' : '')} key={index}>
                                <button onClick={() => { if (item.type != 'folder') { this.changeFrame(item) } else { this.changeCollapse2(item._id ?? item.key) } }} className='flexcb w-100 p-2 hover-gray-no-filter br-5  transition-all'>
                                    <div className={"flexcb w-100 "}>
                                        <div className='flexc gray-filter w-100'>
                                            {item.type == 'folder' && (
                                                <div className='flexcc pld-1'>
                                                    <img className="transition-all " src={'/assets/icons/folder (1).png'} height={16} />
                                                </div>
                                            )}
                                            {item.type == 'page' && (
                                                <div className='flexcc'>
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#007aff20', color: '#007aff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>D</p>
                                                    </div>
                                                    {/* <img className="transition-all opacity-2" src={item.icon ?? '/assets/icons/assignee.svg'} height={16} /> */}
                                                </div>
                                            )}
                                            {item.type == 'recordClassifier' && (
                                                <div className='flexcc'>
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#007aff20', color: '#007aff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>S</p>
                                                    </div>
                                                    {/* <img className="transition-all opacity-2" src={item.icon ?? '/assets/icons/assignee.svg'} height={16} /> */}
                                                </div>
                                            )}
                                            {item.mode == 'planner' && (
                                                <div className='flexcc'>
                                                    {/* <img className="transition-all opacity-2" src={item.icon ?? '/assets/icons/useful/file.svg'} height={16} /> */}
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#7a00ff20', color: '#7a00ff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>P</p>
                                                    </div>
                                                </div>
                                            )}
                                            {item.mode == 'tasklist' && (
                                                <div className='flexcc'>
                                                    {/* <img className="transition-all opacity-2" src={item.icon ?? '/assets/icons/useful/file.svg'} height={16} /> */}
                                                    <div className='br-20 flexcc' style={{ width: 20, height: 20, backgroundColor: '#7a00ff20', color: '#7a00ff' }}>
                                                        <p className='text-smaller text-semibold' style={{ lineHeight: 0 }}>T</p>
                                                    </div>
                                                </div>
                                            )}
                                            <div className={'mld-3'}>
                                                <p className='font-size-12 text-semibold main-c3 '>{checkTranslation(item.title ?? item.name)}</p>
                                            </div>
                                        </div>
                                        <div>
                                            {item.type == 'folder' && (
                                                <div className="flexcc">
                                                    <FramesPlusBut width={this.props.width} colors={this.props.colors} frame={item._id} />
                                                    <img className={"transition flexcc " + ((this.state.collapses2[item._id ?? item.key] == null || this.state.collapses2[item._id ?? item.key] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </button>
                                {/* <div className={'w-100 ' + ((this.state.collapses2[item._id??item.key] == null ? true : this.state.collapses2[item._id??item.key]) ? "Collapsible-is-open" : '')}> */}
                                <Collapsible open={this.state.collapses2[item._id ?? item.key] == null ? true : this.state.collapses2[item._id ?? item.key]}>
                                    {this.showChildren(item._id ?? item.key, data, level + 1)}
                                </Collapsible>
                                {/* </div> */}
                            </div>
                        )
                })}
            </div>
        )
    }

    render() {
        let { list } = this.state
        return (
            <div className='scroll-no-scrollbar h-100'>
                <div className='py-1 px-3 sc-gray2' style={{}}>
                    {this.state.isLoadingList ?
                        (
                            <Loader
                                type="Oval"
                                color="#789"
                                height={50}
                                width={50}
                            />
                        ) :
                        (
                            Array.isArray(list) && list.length > 0 ? (
                                list?.map((prop, index) => {
                                    let name = prop?.applet?.name ? prop?.applet?.name : prop.name
                                    // console.log('proppppppppppdcsd', prop)
                                    return (
                                        <div className='w-100 py-2 bb-gray'>
                                            <button className='flexcb w-100' onClick={() => this.changeCollapse(prop._id)}>
                                                {/* // this.changeApplet(prop) */}

                                                <div className='flexc'>
                                                    {prop.applet.image ?
                                                        <div className='mrd-4'>
                                                            <img className='br-50' width={30} height={30} src={imageAddress(prop.applet?.image, "applet")} />
                                                        </div>
                                                        :
                                                        <div className='mrd-4 flexcc' style={{ position: 'relative', }} >
                                                            <img className="br-50" style={{ width: '40px', height: '40px', objectFit: 'cover', border: '2px solid #ffffff90' }} src={imageAddress(prop?.appletHub?.image, 'profile', 'thumb')} />
                                                            <div className='flexcc' style={{ position: 'absolute', bottom: -6, right: -6, backgroundColor: '#ffffffcc', borderRadius: 20, height: 24, width: 24 }}>
                                                                <img src={'/assets/icons/applets/' + ((prop?.features && prop?.features[0]) ? String(prop?.features[0]).toLowerCase() : String(prop.applet?.type).toLowerCase()) + ".png"} width="22px" style={{ height: 22, borderRadius: 100, objectFit: 'cover', border: '2px solid #ffffff90' }} />
                                                            </div>
                                                        </div>
                                                    }

                                                    <div className='d-flex flex-column' style={{ textAlign: 'start' }}>
                                                        <p className='font-size-14 main-c2'>{prop?.applet?.name ? (prop?.applet?.name) : translate(prop.name)}</p>
                                                        {prop.appletHub &&
                                                            <p className='font-size-12 main-c9'>{prop.appletHub.fullname}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <img className={"transition flexcc " + ((this.state.collapses[prop._id] == null || this.state.collapses[prop._id] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                                </div>
                                            </button>
                                            <Collapsible open={this.state.collapses[prop._id] == null ? true : this.state.collapses[prop._id]}>
                                                <div className='my-1'>
                                                    {this.props.frames?.map((section, i) => {
                                                        // console.log('frameeeeeeeeeeeeeeeeeef', section)
                                                        if (section && (section.parents == null || section.parents.length == 0)) {
                                                            return (
                                                                <div className="w-100 py-1 bb-gray">
                                                                    <button className="flexcb w-100 p-2  br-5" onClick={() => this.changeCollapse2(section._id ?? section.key)}>
                                                                        <div className="flexc text-start">
                                                                            <img className="transition br-20" src={'/assets/profile-def.png'} height={20} width={20} />
                                                                            <div>
                                                                                <p className="font-size-12 mld-3 weight-600 main-c3 " style={{}}>{checkTranslation(section.name)}</p>
                                                                                <p className="font-size-10 mld-3  main-c3 " style={{}}>Applet Name</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className='flexc'>
                                                                            <FramesPlusBut colors={this.props.colors} width={this.props.width} frame={section._id} />
                                                                            <div className="">
                                                                                <img className={"transition flexcc " + ((this.state.collapses2[section._id ?? section.key] == null || this.state.collapses2[section._id ?? section.key] == true) ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                                                            </div>
                                                                        </div>
                                                                    </button>
                                                                    <Collapsible open={this.state.collapses2[section._id ?? section.key] == null ? true : this.state.collapses2[section._id ?? section.key]}>
                                                                        {this.showChildren(section._id ?? section.key, this.props.frames, 0)}
                                                                    </Collapsible>
                                                                </div>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                            </Collapsible>
                                        </div>
                                    )

                                })
                            ) : (<div></div>)
                        )
                    }
                </div>
            </div>
        )
    }
}